import React from 'react';
import { bonuses } from '../data/bonuses';
import { BookCover } from './BookCover';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-19" data-mp="pio8yn0kl492">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-20" data-mp="avl8q8kv4hi1">
        <div className="text-center" data-id="element-21" data-mp="at8v27m50tas">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-22" data-mp="fteh989n1nlh">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-23" data-mp="1t3ou0sok0y7">
            Five instant-use <span className="text-gold" data-id="element-24" data-mp="3o2mz1kkfrgcs">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-25" data-mp="3t0g4uchtu8cj">
            The volumes give you the year. These five get you through your very
            next class — before, during and at the end of it.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-26" data-mp="1r8tbw5edk3df">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-27" data-mp="3icvdrgg4qs41" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="h-[230px] w-full border-b border-navy-line object-cover sm:h-[265px]" data-id="element-28" data-mp="2zf29oatrsc52" /> : <div className="flex h-[230px] items-center justify-center border-b border-navy-line bg-gradient-to-b from-navy-mid to-navy-card sm:h-[265px]" data-id="element-29" data-mp="33gdzohgk2zds">
                  <BookCover kicker={`Bonus ${bonus.number}`} title={bonus.title.replace('™', '')} accent={bonus.accent} className="h-[82%] w-auto -rotate-2" data-id="element-30" data-mp="irga6xiuwf2x" />
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-31" data-mp="3ljunsmx4iorp">
                <div className="flex flex-wrap items-center gap-2" data-id="element-32" data-mp="3lk4bu4ylylur">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-33" data-mp="3qixu0aoub119">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-34" data-mp="2xu09e0x5os5c">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-white" data-id="element-35" data-mp="37jtjsylkb180">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-36" data-mp="2a57iwjzazci4">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}